import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'

import { EXPLAIN_THE_WIZARD_FEATURE_FLAG } from './constants'

export const useIsExplainTheWizardEnabled = () =>
  useIsOptimizelyFeatureEnabled(EXPLAIN_THE_WIZARD_FEATURE_FLAG)
